<template>
  <div class="body">
    <div class="app">
      <span class="text">{{ title }}</span>
    </div>
    <div class="bodyy">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <el-form-item label="执行老师：" prop="executiveTeacher">
          <el-select
            class="select"
            v-model="ruleForm.executiveTeacher"
            placeholder="请选择执行老师"
            style="width: 80%"
            filterable
            clearable
          >
            <el-option
              v-for="source in taskCreatorList"
              :key="source.id"
              :value="source.id"
              :label="source.realname"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="任务名称：" prop="taskName">
          <el-select
            class="select"
            v-model="ruleForm.taskName"
            placeholder="请选择任务名称"
            style="width: 80%"
            filterable
            clearable
          >
            <el-option
              v-for="source in TodoallList"
              :key="source.id"
              :value="source.id"
              :label="source.taskName"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="学科名称：" prop="categoryId">
          <el-select
            class="select"
            v-model="ruleForm.categoryId"
            placeholder="请选择学科名称"
            style="width: 80%"
            filterable
            clearable
          >
            <el-option
              v-for="source in courses"
              :key="source.id"
              :value="source.id"
              :label="source.categoryName"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="任务详情:" prop="taskDetails">
          <el-input
            type="textarea"
            show-word-limit
            :autosize="{ minRows: 5, maxRows: 5 }"
            v-model="ruleForm.taskDetails"
            style="width: 80%"
            clearable
            placeholder="请输入任务详情"
          >
          </el-input>
        </el-form-item>

        <!-- <el-form-item label="完成进度：" prop="marketSuccess">
          <el-radio-group v-model="ruleForm.marketSuccess">
            <el-radio :label="1">待完成</el-radio>
            <el-radio :label="2">已完成</el-radio>
            <el-radio :label="3">进行中</el-radio>
            <el-radio :label="4">已取消</el-radio>
          </el-radio-group>
        </el-form-item> -->


        <el-form-item label="上传资料:" prop="taskDetails">
          <div></div>
          <div style="display: flex; padding-left: 8%">
            <el-upload
              class="avatar-uploader"
              action=""
              drag
              :on-remove="handleRemove"
              :before-upload="beforeUpload"
              :file-list="fileList"
              :http-request="handleUpload"
              :auto-upload="true"
              :limit="10"
              accept=".png,.jpg,.pdf,.mp4,.doc,.xls,.xlsx,.ppt,.docx"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>

        <el-form-item v-if="title === '编辑待办任务'" label="办理结果:" prop="taskDetails">
          <el-input
            type="textarea"
            maxlength="200"
            show-word-limit
            :autosize="{ minRows: 5, maxRows: 5 }"
            v-model="results"
            style="width: 80%"
            clearable
            placeholder="请输入办理结果"
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <div style="height: 200px; overflow-y: auto;display: flex;margin-left: 201px;" v-if="this.row">
            <div>
              <span
              style="display: block;color: #409eff;"
              v-for="(itme, index) in impDatas"
              :key="index"
              @click="handleDownload_s(itme)"
              >{{ itme.name }}</span>
            </div>
            <div style="margin-left: 100px">
              <span
              style="display: block;color: #409eff;"
              v-for="(itme, index) in impDatas"
              :key="index"
              @click="handleDownload_d(itme.url)"
              >X</span>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="学生(老师)：" prop="studentName">
          <el-select
            class="select"
            v-model="ruleForm.studentName"
            placeholder="请选择学生(老师)"
            style="width: 80%"
            filterable
            clearable
          >
            <el-option
              v-for="source in taskCreatorList"
              :key="source.id"
              :value="source.id"
              :label="source.realname"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="截止日期:" prop="deadline">
          <!-- <el-date-picker
            v-model="ruleForm.deadline"
            style="width: 80%"
            clearable
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            placeholder="选择截止日期"
          >
          </el-date-picker> -->

          <el-date-picker
            style="width: 80%"
            v-model="ruleForm.deadline"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择截止日期">
          </el-date-picker>

        </el-form-item>


        <el-form-item label="截止开始时间:" prop="expirationStartDate">
          <!-- <el-date-picker
            v-model="ruleForm.expirationStartDate"
            style="width: 80%"
            clearable
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            placeholder="选择截止日期"
          >
          </el-date-picker> -->


          <el-time-select
            v-model="ruleForm.expirationStartDate"
            style="width: 80%; margin-left: -32px;"
            :picker-options="{
              start: '06:00',
              step: '00:01',
              end: '24:00'
            }"
            placeholder="选择截止开始时间">
          </el-time-select>

        </el-form-item>


        <el-form-item label="截止结束时间:" prop="expirationEndDate">
          <!-- <el-date-picker
            v-model="ruleForm.expirationEndDate"
            style="width: 80%"
            clearable
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            placeholder="选择截止日期"
          >
          </el-date-picker> -->

          <el-time-select
            v-model="ruleForm.expirationEndDate"
            style="width: 80%; margin-left: -32px;"
            :picker-options="{
              start: '06:00',
              step: '00:01',
              end: '24:00'
            }"
            placeholder="选择截止结束时间">
          </el-time-select>

        </el-form-item>

        <el-form-item label="任务创建人：" prop="taskCreator">
          <el-select
            class="select"
            v-model="ruleForm.taskCreator"
            placeholder="请选择任务创建人"
            style="width: 80%; margin-left: -19px;"
            filterable
            clearable
          >
            <el-option
              v-for="source in taskCreatorLists"
              :key="source.id"
              :value="source.id"
              :label="source.realname"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <div v-if="!showType">
      <el-row>
        <el-col
          :span="24"
          style="text-align: center; bottom: 25px; width: 80%"
        >
          <el-button
            type="primary"
            @click="handleDownload"
            class="btns"
            size="small"
            icon="el-icon-d-arrow-left"
            >返回</el-button
          >
          <el-button
            @click="submitForm"
            class="btns"
            type="primary"
            size="small"
            icon="el-icon-check"
            >保存</el-button
          >
        </el-col>
      </el-row>
    </div>

    <div v-else>
      <el-row>
        <el-col
          :span="24"
          style="text-align: center;  bottom: 25px; width: 100%"
        >
          <el-button
            type="primary"
            @click="handleDownload1"
            class="btns"
            size="small"
            icon="el-icon-d-arrow-left"
            >取消</el-button
          >
          <el-button
            @click="submitForm"
            class="btns"
            type="primary"
            size="small"
            icon="el-icon-check"
            >保存</el-button
          >
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
import {
  ApiAddTodoUpdates,
  ApiAddTodoTasks,
  ApiGetStudentList,
  ApiTeacherAll,
  ApiAddTodoall,
} from "../api/apiTask";
import axios from "axios";
import apiBaseUrl from "../../config/api";
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
export default {
  props:['showType','itmesID','rows', 'typeTil'],
  data() {
    return {
      isItme:false,
      taskCreatorList: [],
      taskCreatorLists: [],
      studentList: [],
      TodoallList: [],
      ruleForm: {
        executiveTeacher: "",
        studentName: "",
        taskCreator: "",
        taskName: "",
        deadline: "",
        taskDetails: "",
        impData: "",
        marketSuccess:'',
        expirationStartDate:'',
        expirationEndDate:'',
        categoryId:'',
      },
      rules: {
        executiveTeacher: [{ required: true, message: '请选择执行老师', }],
        taskCreator: [{ required: true, message: '请选择任务创建人', }],
        taskName: [{ required: true, message: '请选择任务名称', }],
        categoryId: [{ required: true, message: '请选择学科名称', }],
        expirationStartDate: [{ required: true, message: '请选择开始截止日期', }],
        expirationEndDate: [{ required: true, message: '请选择结束截止日期', }],
        deadline: [{ required: true, message: '请选择截止日期', }],
        studentName: [{ required: true, message: '请选择学生', }],
      },
      row: null,
      title: "添加待办任务",
      fileList: [],
      screenshot: [],
      impDatas: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      results:'',
      courses:[],
    };
  },
  created() {},
  mounted() {
    axios.get(`${apiBaseUrl}/schedule/categorylist`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }) .then(response => {
      this.courses = response.data.data
    }).catch(error => {
       console.error(error)
    })

    this.getApiTeacherAll();
    // this.row = this.$route.query.row;
    if(this.$route.query.row){
      this.isItme = true
      this.row = this.$route.query.row;
    }

    if(this.rows){
      this.isItme = false
      this.row = this.rows
    }

    if (this.row) {
      this.title = "编辑待办任务";
      this.handleEcho();
    }


  },
  methods: {

    handleDownload1(){
      this.$emit('handleEventClr')
    },

    handleDownload_d(url){
      this.impDatas = this.impDatas.filter((itme)=>{
          return itme.url !== url
      })
    },
    handleDownload_s(e) {
      let url = e.url.replace('http','https')
      fetch(url)
        .then((response) => response.blob())
        .then((result) => {
            const objectUrl = window.URL.createObjectURL(result)
            const link = document.createElement('a')
            link.href = objectUrl
            link.download = e.name
            link.click()
            link.remove()
            window.URL.revokeObjectURL(objectUrl)
        })
    },
    getFileName(name) {
      return name.substring(name.lastIndexOf("."));
    },
    beforeUpload(file) {
      // 限制上传类型
      const fileExtensions =
        this.getFileName(file.name) === ".bmp" ||
        this.getFileName(file.name) === ".tif" ||
        this.getFileName(file.name) === ".gif" ||
        this.getFileName(file.name) === ".docx" ||
        this.getFileName(file.name) === ".svg" ||
        this.getFileName(file.name) === ".psd" ||
        this.getFileName(file.name) === ".webp" ||
        this.getFileName(file.name) === ".apng" ||
        this.getFileName(file.name) === ".ai" ||
        this.getFileName(file.name) === ".avif" ||
        this.getFileName(file.name) === ".png" ||
        this.getFileName(file.name) === ".pdf" ||
        this.getFileName(file.name) === ".mp4" ||
        this.getFileName(file.name) === ".doc" ||
        this.getFileName(file.name) === ".xls" ||
        this.getFileName(file.name) === ".xlsx" ||
        this.getFileName(file.name) === ".ppt" ||
        this.getFileName(file.name) === ".jpg";
      //限制的上限为20M
      const max20M = file.size / 1024 / 1024 < 100;
      if (!fileExtensions) {
        this.$message.error("上传文件类型只能是 .png, .jpg, .pdf 格式!");
      }
      if (!max20M) {
        this.$message.error("上传文件大小不能超过 20MB!");
      }
      return fileExtensions && max20M;
    },
    handleUpload(option) {
      var obj = option.file.name;
      var index = obj.lastIndexOf(".");
      obj = obj.substring(index, obj.length);
      // 生成的文件名，保留文件后缀名，进行拼接
      let objName = getFileNameUUID() + this.getFileName(option.file.name);
      // 调用 ali-oss 中的方法,flieName是存放的文件夹名称，可自己定义
      put(`mz_pc/${objName}`, option.file).then((res) => {
        let file = {
          uid: option.file.uid,
          url: res.url,
          name: option.file.name,
        };
        this.screenshot.push(file);
        // 上传成功之后，转换真实的地址
        signatureUrl(`mz_pc/${objName}`).then((res) => {
          console.log(res);
        });
      });
    },
    handleRemove(file, fileList) {
      let list = [];
      this.screenshot.map((itme) => {
        fileList.map((itmes) => {
          if (itme.uid.toString() == itmes.uid.toString()) {
            console.log(itme, "itmes");
            list.push(itme);
          }
        });
      });

      this.screenshot = list;
    },
    handleEcho() {
      console.log(this.row);
      this.ruleForm.executiveTeacher = this.row.executiveTeacher;
      this.ruleForm.studentName = this.row.studentId;
      this.ruleForm.taskCreator = this.row.taskUser;
      this.ruleForm.taskName = this.row.taskId;
      this.ruleForm.deadline = this.row.expirationDate;
      this.ruleForm.taskDetails = this.row.taskDetail;
      this.ruleForm.marketSuccess = this.row.marketSuccess;

      this.ruleForm.categoryId = this.row.categoryId ? this.row.categoryId : ''

      this.ruleForm.expirationStartDate = this.row.expirationStartDate;
      this.ruleForm.expirationEndDate = this.row.expirationEndDate;

      // this.impDatas = this.row.impDatas ? JSON.parse(this.row.impDatas) : [];
      this.impDatas = this.row.imp ? JSON.parse(this.row.imp) : [];

      this.results = this.row.handlingResult
    },
    handleIsNull() {
      let { executiveTeacher, studentName, taskCreator, taskName, deadline } =
        this.ruleForm;
      if (executiveTeacher) {
        if (taskCreator) {
          if (taskName) {
            if(studentName){
              if (deadline) {
                return true;
              } else {
                this.$message.warning("截止日期不能为空");
              }
            }else {
             this.$message.warning("学生姓名不能为空");
            }
          } else {
            this.$message.warning("任务名称不能为空");
          }
        } else {
          this.$message.warning("任务创建人不能为空");
        }
      } else {
        this.$message.warning("执行老师不能为空");
      }
    },
    handleDownload() {
      this.$router.go(-1);
    },
    getApiAddTodoUpdate() {
      let url = [];
      if (this.screenshot.length > 0) {
        // this.screenshot.map((itme) => {
        //   url.push(itme.url);
        // });
        this.screenshot.map((itme) => {
          url.push(itme);
        });
      }

      let listData = [...url, ...this.impDatas];

      let ruleForm = {}
      if(this.typeTil === '编辑'){
        ruleForm = {
          executiveTeacher: this.ruleForm.executiveTeacher,
          studentId: this.ruleForm.studentName,
          taskUser: this.ruleForm.taskCreator,
          taskId: this.ruleForm.taskName,
          expirationDate: this.ruleForm.deadline,
          id: this.row.id,
          taskDetail: this.ruleForm.taskDetails,
          // impData: listData.join(","),
          // impData: JSON.stringify(listData),
          imp: JSON.stringify(listData),
          communicationId: this.itmesID ? this.itmesID : '',
          toDoType:this.itmesID ? 2 : 1,

          categoryId: this.ruleForm.categoryId ? this.ruleForm.categoryId : '',

          expirationStartDate:this.ruleForm.expirationStartDate,
          expirationEndDate:this.ruleForm.expirationEndDate,
          handlingResult: this.results
        };
      }else{
        ruleForm = {
          executiveTeacher: this.ruleForm.executiveTeacher,
          studentId: this.ruleForm.studentName,
          taskUser: this.ruleForm.taskCreator,
          taskId: this.ruleForm.taskName,
          expirationDate: this.ruleForm.deadline,
          id: this.row.id,
          taskDetail: this.ruleForm.taskDetails,
          // impData: listData.join(","),
          // impData: JSON.stringify(listData),
          imp: JSON.stringify(listData),
          communicationId: this.itmesID ? this.itmesID : '',
          toDoType:this.itmesID ? 2 : 1,


          categoryId: this.ruleForm.categoryId ? this.ruleForm.categoryId : '',

          expirationStartDate:this.ruleForm.expirationStartDate,
          expirationEndDate:this.ruleForm.expirationEndDate,
          handlingResult: this.results

        };
      }

      ApiAddTodoUpdates(ruleForm).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.message);
          this.row = null;
          if(this.itmesID){
            this.$emit('handleEventClr')
          }else{
            this.$router.go(-1);
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    submitForm() {
      let isNull = this.handleIsNull();
      let categoryIdCopy =  this.ruleForm.categoryId 
      if (isNull) {
        if (this.row && this.isItme) {
          this.getApiAddTodoUpdate();
        } else {
          if(this.typeTil === '编辑'){
            this.getApiAddTodoUpdate();
          }else{
          this.$refs["ruleForm"].validate((valid) => {
            if (valid) {
              let url = [];
              if (this.screenshot.length > 0) {
                  this.screenshot.map((itme) => {
                    // url.push(itme.url);
                    url.push(itme);
                  });
              }

              let ruleForm = {
                executiveTeacher: this.ruleForm.executiveTeacher,
                studentId: this.ruleForm.studentName,
                taskUser: this.ruleForm.taskCreator,
                taskId: this.ruleForm.taskName,
                expirationDate: this.ruleForm.deadline,
                taskDetail: this.ruleForm.taskDetails,
                categoryId: categoryIdCopy ? categoryIdCopy : '',
                // impData: url ? JSON.stringify(url) : "{}",
                imp: url.length > 0 ? JSON.stringify(url) : "[]",
                impData: url.length > 0 ? JSON.stringify(url) : "[]",
                communicationId: this.itmesID ? this.itmesID : '',
                toDoType:this.itmesID ? 2 : 1,
                expirationStartDate:this.ruleForm.expirationStartDate,
                expirationEndDate:this.ruleForm.expirationEndDate,
                handlingResult: this.results
              };

              console.log(ruleForm,'111111111111')

              ApiAddTodoTasks(ruleForm).then((res) => {
                  if (res.code == 200) {
                    this.$message.success(res.message);
                    if(this.itmesID){
                      this.$emit('handleEventClr')
                    }else{
                      this.$router.go(-1);
                    }
                  } else {
                    this.$message.error(res.message);
                  }
                })
                .catch((error) => {
                  console.error(error);
                });
            } else {
              console.log("error submit!!");
              return false;
            }
          });
        }
      }
      }
    },

    getApiTeacherAll() {

      axios.get(`${apiBaseUrl}/teacher/allJob`,{headers:{'authorization': sessionStorage.getItem('tokenInfo') }}) .then(response => {
        this.taskCreatorLists = response.data.data
      }).catch(error => {
        this.$message.error(error)
      })

      ApiTeacherAll().then((res) => {
        let { data } = res;
        this.taskCreatorList = data;
      });


      ApiGetStudentList().then((res) => {
        let { data } = res;
        this.studentList = data;
      });

      ApiAddTodoall().then((res) => {
        let { data } = res;
        this.TodoallList = data;
      });
      
    },
  },
};
</script>
<style scoped >
/* .screenshot >>> .el-form-item__label {
  float: unset !important;
} */
.app {
  width: 100%;
  border-radius: 10px;
}

.text {
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: 600;
}

.app img {
  width: 100%;
}

.body {
  padding: 15px;
  /* margin-top: 20px; */
}

.bodyy {
  margin-top: 30px;
}

.demo-ruleForm > .el-form-item {
  margin-bottom: 3.86667vw !important;
}

.input-container,
.upload-container {
  margin-bottom: 15px;
}

.num {
  font-size: 16px;
}

label {
  display: inline-block;
  margin-bottom: 5px;
}

.input {
  width: 82vw;
  /* height: 20px; */
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
  font-size: 16px;
}

.button {
  width: 300px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 20px;
  font-size: 16px;
}
.el-textarea__inner >>> .el-textarea .el-input--suffix {
  width: 200px;
  min-height: 200px;
}

.btn {
  width: 100%;
  height: 50px;
}

.select {
  width: 88vw;
  border: 1px solid #ccc;
  border-radius: 10px;
  font-size: 16px;
  margin-bottom: 0.66667vw;
}

.required {
  color: red;
}

.button-container {
  /* display: flex;
  justify-content: space-between; */
  text-align: center;
  margin-top: 50px;
}

/* /* .button {
  flex: 1;
  margin-right: 10px;
}  */

.submit {
  background-color: #007bff;
  color: #fff;
}

.success {
  background-color: #ccc;
  color: white;
  /* 其他样式属性 */
}

.avatar-uploader >>> .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-right: 88%;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .el-radio-group {
    display: flex;
    padding-top: 7px;
  }

  .screenshot {
    width: 150px;
  }
}

.avatar-uploader >>> .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-right: 88%;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/TeacherScheduling/addDelegatedTasks.vue